import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

import {
  FaMapMarkerAlt,
  FaPhone,
  FaArrowRight,
  FaCheckCircle,
  FaGlobe,
  FaWhatsapp,
  FaClock,
  FaStar,
  FaUserMd,
  FaAward,
  FaHeartbeat,
  FaRegLightbulb,
  FaShieldAlt,
  FaCertificate,
  FaUserCheck,
  FaCoins,
  FaDirections,
} from "react-icons/fa";
import { GiMedicalPack } from "react-icons/gi";
import {
  MdOutlineHealthAndSafety,
  MdSupportAgent,
} from "react-icons/md";

import tambaramskin from "./../../../../assets/images/tambaramskinicon.png";
import tambaramhair from "./../../../../assets/images/tambaramhairicon1.png";
import tambaramleaf from "./../../../../assets/images/tambaramleaf.jpg";
import tambarambanner3 from "./../../../../assets/images/tambarambanner4.png";

import img1 from "./../../../../assets/images/autoscroll1.jpg";
import img2 from "./../../../../assets/images/autoscroll2.jpg";
import img3 from "./../../../../assets/images/autoscroll3.jpg";
import img4 from "./../../../../assets/images/autoscroll4.jpg";
import img5 from "./../../../../assets/images/autoscroll5.jpg";
import img6 from "./../../../../assets/images/autoscroll6.jpg";
import img7 from "./../../../../assets/images/autoscroll7.jpg";
import img8 from "./../../../../assets/images/autoscroll8.jpg";
import img9 from "./../../../../assets/images/autoscroll9.jpg";
import img10 from "./../../../../assets/images/autoscroll10.jpg";
import img11 from "./../../../../assets/images/autoscrollskin1.png";
import img12 from "./../../../../assets/images/autoscrollskin2.png";
import img13 from "./../../../../assets/images/autoscrollskin3.png";
import img14 from "./../../../../assets/images/autoscrollskin4.png";
import img15 from "./../../../../assets/images/autoscrollskin5.png";
import img16 from "./../../../../assets/images/autoscrollskin6.png";
import img17 from "./../../../../assets/images/autoscrollskin7.png";
import img18 from "./../../../../assets/images/autoscrollskin8.png";
import img19 from "./../../../../assets/images/autoscrollskin9.png";
import img20 from "./../../../../assets/images/autoscrollskin10.png";

import chennaitambarm from "./../../../../assets/images/chennaitambarmhair.jpg";
import chennaitambarmskin from "./../../../../assets/images/chennaitambaramskin.jpg";
import chennaitambaramhomeopathy from "./../../../../assets/images/chennaitambaramhomeopathy.png";
import chennaitambaramskin1 from "./../../../../assets/images/chennaitambaramskin1.jpg";
import chennaitambaramskin2 from "./../../../../assets/images/chennaitambaramskin2.jpg";
import chennaitambarampcos from "./../../../../assets/images/chennaitambarampcos.jpg";
import chennaitambaramchronic from "./../../../../assets/images/chennaitambaramchronic.png";
import chennaitambarammentalhealth from "./../../../../assets/images/chennaitambarammentalhealth.jpg";

import chennaivalasaravakkamhair from "./../../../../assets/images/chennaivalasaravakkamhair1.jpg";
import chennaivalasaravakkamhair1 from "./../../../../assets/images/chennaivalasaravakkamhair2.jpg";
import chennaivalasaravakkamhair2 from "./../../../../assets/images/chennaivalasaravakkamhair3.jpg";
import chennaivalasaravakkamhair3 from "./../../../../assets/images/chennaivalasaravakkamhair4.jpg";
import chennaivalasaravakkamdental1 from "./../../../../assets/images/chennaivalasaravakkamdental1.jpg";
import chennaivalasaravakkamdental2 from "./../../../../assets/images/chennaivalasaravakkamdental4.jpg";
import chennaivalasaravakkamdental3 from "./../../../../assets/images/chennaivalasaravakkamdental5.jpg";

import hcuraHeroVideo from "./../../../../assets/video/hcura-hero2.mp4";
import hcuraHeroVideo1 from "./../../../../assets/video/hcura-hero6.mp4";
import hcuraHeroVideo2 from "./../../../../assets/video/hcura-hero4.mp4";

const ICON_MAP = {
  "quality-icon": FaAward,
  "personalized-icon": FaUserCheck,
  "affordable-icon": FaCoins,
};

const Icon = ({ name, size = 24, className = "", ariaHidden = true }) => {
  const Comp = ICON_MAP[name];
  if (!Comp) return <span className={className} aria-hidden={ariaHidden} />;
  return <Comp size={size} className={className} aria-hidden={ariaHidden} />;
};

const Salem = () => {
  const [activeLocation, setActiveLocation] = useState("salem");
  const [activeService, setActiveService] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isChanging, setIsChanging] = useState(false);
  const sectionRef = useRef(null);
  const servicesRef = useRef(null);

  const [isAutoScrollPaused, setIsAutoScrollPaused] = useState(false);
  const autoScrollRef = useRef(null);

  const [valasaravakamchennaiBaModalOpen, setTambaramBaModalOpen] = useState(false);
  const [valasaravakamchennaiBaModalItems, setTambaramBaModalItems] = useState([]);
  const [valasaravakamchennaiBaModalStartIndex, setTambaramBaModalStartIndex] = useState(0);

  const whyChooseControls = useAnimation();
  const [whyChooseRef, whyChooseInView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  useEffect(() => {
  const videos = document.querySelectorAll("video");

  videos.forEach((video) => {
    video.muted = true;
    video.defaultMuted = true;
  });
}, []);

  const scrollGallery = (direction) => {
    const container = document.getElementById("scrollableGrid");
    const cardWidth = 420;
    const currentScroll = container.scrollLeft;
    const maxScroll = container.scrollWidth - container.clientWidth;

    let newScrollPosition;
    if (direction === "next") {
      newScrollPosition = Math.min(currentScroll + cardWidth, maxScroll);
    } else {
      newScrollPosition = Math.max(currentScroll - cardWidth, 0);
    }

    container.scrollTo({
      left: newScrollPosition,
      behavior: "smooth",
    });

    updateScrollIndicators();
  };

  const updateScrollIndicators = () => {
    const container = document.getElementById("scrollableGrid");
    const progressBar = document.getElementById("progressBar");
    const prevBtn = document.getElementById("prevBtn");
    const nextBtn = document.getElementById("nextBtn");

    if (!container || !progressBar) return;

    const scrollPercentage =
      (container.scrollLeft / (container.scrollWidth - container.clientWidth)) *
      100;
    progressBar.style.width = `\${scrollPercentage}%`;

    if (prevBtn) prevBtn.disabled = container.scrollLeft <= 0;
    if (nextBtn)
      nextBtn.disabled =
        container.scrollLeft >=
        container.scrollWidth - container.clientWidth - 10;
  };

  useEffect(() => {
    if (valasaravakamchennaiBaModalOpen) {
      const container = document.getElementById("scrollableGrid");
      if (container) {
        container.addEventListener("scroll", updateScrollIndicators);
        updateScrollIndicators();

        const cardWidth = 420;
        container.scrollLeft =
          valasaravakamchennaiBaModalStartIndex * cardWidth;

        return () => {
          container.removeEventListener("scroll", updateScrollIndicators);
        };
      }
    }
  }, [valasaravakamchennaiBaModalOpen, valasaravakamchennaiBaModalStartIndex]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (whyChooseInView) {
      whyChooseControls.start("visible");
    }
  }, [whyChooseControls, whyChooseInView]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (autoScrollRef.current) {
      clearInterval(autoScrollRef.current);
      autoScrollRef.current = null;
    }

    if (!isAutoScrollPaused) {
      autoScrollRef.current = setInterval(() => {
        setActiveService((prev) => {
          const next = (prev + 1) % advancedServices.length;
          setIsChanging(true);
          setTimeout(() => {
            setIsChanging(false);
          }, 300);
          return next;
        });
      }, 10000);
    }

    return () => {
      if (autoScrollRef.current) {
        clearInterval(autoScrollRef.current);
        autoScrollRef.current = null;
      }
    };
  }, [isAutoScrollPaused]);

  useEffect(() => {
    document.title = "H-Cura Clinic | Best Hair, Skin, Homeopathy & Dental Clinic in Salem";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Advanced hair loss, PRP, skin, dental and homeopathy treatments at H-Cura Clinic in Salem. Book your consultation with expert doctors today."
      );
    }
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "Best hair clinic in Salem, Best hair treatment in Salem, Best hair care clinic in Salem, Best hair doctor in Salem, Advance hair treatment in Salem, PRP treatment for hair Salem, Best PRP Treatment Doctors in Salem, PRP treatment for skin and hair, Best Hair PRP Therapy in Salem, Hair loss treatment in Salem, Hair growth treatment in Salem, Best hair treatment near me in Salem, Best clinic near me in Salem, Affordable hair loss treatment in Salem, PRP therapy for hair loss in Salem, Best homeopathy doctor for hair loss in Salem, Best Hair, Skin, Dental & Homeopathy Clinic in Salem, Best Hair Loss Treatment Clinic in Salem, PRP Hair Treatment in Salem, Best Skin Treatment Clinic in Salem, Best Dental Clinic in Salem, Best Homeopathy Clinic in Salem, Advanced Hair & Skin Treatment in Salem, Multispecialty Hair, Skin & Dental Clinic in Salem"
      );
    }
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute("href", "https://www.h-cura.com/multispecialty-clinic-in-salem-tamilnadu/");
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", "https://www.h-cura.com/multispecialty-clinic-in-salem-tamilnadu/");
      document.head.appendChild(canonicalLink);
    }
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 12,
      },
    },
  };

  const locations = {
    salem: {
      name: "SALEM",
      address: "Anandam Arcade first floor, Bharathi St, Swarnapuri, Salem, Tamil Nadu 636004",
      phone: "+91 99646 88333",
      hours: "All days 10 am to 8pm",
      nearbyAreas: "Swarnapuri, Fairlands, Alagapuram, Swarnapuri",
      popularServices: [
        "PRP Hair Treatment",
        "Advanced Skin Care",
        "Dental Implants",
        "Homeopathy Wellness",
      ],
      specialties: "Hair, Skin & Dental Care",
      mapUrl: "https://share.google/tJRNayilYxawllMoW",
      video: hcuraHeroVideo1,
    }
  };

  const advancedServices = [
    {
      id: "hair",
      title: "Hair Treatments in Salem – Restore Stronger, Healthier Hair",
      subtitle: "Stop Hair Loss. Stimulate Natural Hair Growth.",
      description:
        "Regain your confidence with advanced hair treatments in Salem designed to control hair fall and promote natural regrowth. At H-Cura Salem, specialists provide PRP hair treatment, scalp therapies, and personalized treatment plans that strengthen hair follicles and improve scalp health. Many patients notice visible improvement within a few months.",
      image: chennaitambarm,
      treatments: [
        {
          name: "PRP Hair Treatment Salem",
          description: "Stimulates natural hair regrowth using your own plasma. No surgery, strong roots, and quick recovery.",
          icon: "prp-icon",
          image: chennaivalasaravakkamhair,
          benefits: ["Promotes natural hair growth", "Strengthens hair roots", "No surgery required", "Quick recovery time"],
        },
        {
          name: "QR678 Hair Treatment Salem",
          description: "Plant-based advanced hair regrowth therapy that stimulates hair follicles for natural results.",
          icon: "gfc-icon",
          image: chennaivalasaravakkamhair1,
          benefits: ["Natural extracts", "Quick visible results", "Non-surgical procedure", "Safe and effective"],
        },
      ],
      testimonial: { quote: "H-Cura Salem helped me reduce hair fall with PRP treatment. Great results and support.", author: "Prasad", location: "Hair Treatment" },
    },
    {
      id: "skin",
      title: "Skin Treatments in Salem – Clear, Healthy Skin",
      subtitle: "Treat Skin Concerns. Reveal a Younger Glow.",
      description:
        "Achieve clear, healthy skin with advanced skin treatments in Salem for acne, pigmentation, dark spots, and wrinkles using safe and effective clinical procedures designed to deliver visible and lasting results.",
      image: chennaitambarmskin,
      treatments: [
        {
          name: "HydraFacial Treatment Salem",
          description: "Deep cleansing facial that provides instant glow and hydration. Refresh your skin immediately.",
          icon: "hydrafacial-icon",
          image: chennaitambaramskin1,
          benefits: ["Deeply cleanses skin", "Provides instant glow", "No recovery time", "Customized care"],
        },
        {
          name: "Laser Skin Treatment Salem",
          description: "Get safe laser skin treatment in Salem to remove dark spots, acne scars, and restore smooth, even-toned skin.",
          icon: "pigmentation-icon",
          image: chennaivalasaravakkamhair3,
          benefits: ["Removes dark spots", "Evens skin tone", "Smoothens skin", "Long-lasting results"],
        },
      ],
      testimonial: { quote: "My acne and pigmentation improved a lot after treatment at H-Cura Salem.", author: "Sneha", location: "Skin Care" },
    },
    {
      id: "dental",
      title: "Dental Care in Salem – Healthy Teeth & Confident Smile",
      subtitle: "Treat Dental Issues. Achieve a Beautiful Smile.",
      description:
        "Restore healthy teeth and enhance your smile with modern dental treatments in Salem using comfortable and advanced techniques that help you achieve a confident smile.",
      image: "https://images.unsplash.com/photo-1606811971618-4486d14f3f99?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
      treatments: [
        {
          name: "Invisible Braces Salem",
          description: "Straighten your teeth with invisible braces — clear, comfortable, and removable for easier eating.",
          icon: "aligner-icon",
          image: chennaivalasaravakkamdental1,
          benefits: ["Nearly invisible", "Removable and clear", "Comfortable to wear", "Fewer clinic visits"],
        },
      ],
      testimonial: { quote: "The invisible braces were comfortable and effective. My smile looks much better now.", author: "Pavan R", location: "Dental Care" },
    },
    {
      id: "homeopathy",
      title: "Homeopathy in Salem – Natural Healing for Complete Wellness",
      subtitle: "Safe, Natural Medicine for Better Health.",
      description:
        "Improve overall health naturally with expert homeopathy treatments in Salem for chronic conditions, hormonal imbalance, stress, and long-term wellness using safe natural remedies.",
      image: chennaitambaramhomeopathy,
      treatments: [
        {
          name: "PCOS Treatment in Salem",
          description: "Natural hormone-balancing treatments using homeopathy designed to balance cycles safely.",
          icon: "hormonal-icon",
          image: chennaitambarampcos,
          benefits: ["Treats root cause", "Safe and natural", "Long-term balance", "Personalized plans"],
        },
        {
          name: "Chronic Disease Treatment",
          description: "Natural care for diabetes, BP, joint pain, and other long-term health conditions with homeopathy.",
          icon: "chronic-icon",
          image: chennaitambaramchronic,
          benefits: ["Reduces medicine dependency", "Targets root causes", "Safe for all patients", "Improves daily health"],
        },
      ],
      testimonial: { quote: "Homeopathy treatment helped balance my hormones naturally. Very positive results.", author: "Arthi J", location: "Women’s Health" },
    },
  ];

  const testimonials = [
    { name: "Prasad", location: "Salem", text: "H-Cura Salem helped me reduce hair fall with PRP treatment. Great results and support.", rating: 5, service: "Hair Treatment" },
    { name: "Priya", location: "Salem", text: "My acne and pigmentation improved a lot after treatment. The skin treatment here gave me clear and healthy skin.", rating: 5, service: "Skin Care" },
    { name: "Sai Kumar", location: "Salem", text: "The invisible braces were comfortable and effective. My smile looks much better now.", rating: 5, service: "Dental Care" },
  ];

  const features = [
    { icon: <FaMapMarkerAlt />, title: "Prime Location in Salem", description: "Conveniently located in central Salem, H-Cura Multispecialty Clinic is easily accessible from major residential and commercial areas across the city.", highlight: "Good Location" },
    { icon: <FaUserMd />, title: "Expert Specialists", description: "Our team of experienced doctors specializes in Hair Treatment, Skin Care, Dental Solutions, and Homeopathy, providing advanced treatments.", highlight: "Expert Care" },
    { icon: <GiMedicalPack />, title: "Advanced Technology", description: "We use advanced medical equipment and proven clinical techniques for PRP Hair Treatment in Salem, skin rejuvenation, and digital dentistry.", highlight: "Modern Equipment" },
    { icon: <FaHeartbeat />, title: "Women’s Health Focus", description: "Specialized expertise in women’s health concerns, hormonal balance, and comprehensive wellness care using safe and natural homeopathic remedies.", highlight: "Complete Care" },
    { icon: <FaAward />, title: "Proven Results", description: "Hundreds of satisfied patients from Salem trust us for effective treatments that deliver visible and long-lasting results.", highlight: "Happy Patients" },
    { icon: <FaRegLightbulb />, title: "Personalized Care", description: "Every treatment plan is customized according to the individual needs of each patient, ensuring the best possible outcomes.", highlight: "Individual Treatment" },
    { icon: <MdOutlineHealthAndSafety />, title: "Safety Standards", description: "Strict hygiene protocols, sterilized equipment, and international safety standards ensure complete patient safety.", highlight: "Safe Treatment" },
    { icon: <MdSupportAgent />, title: "Continuous Support", description: "Regular follow-ups, patient guidance, and dedicated support throughout your treatment journey to ensure optimal results.", highlight: "Ongoing Support" },
  ];

  const testimonialQuotes = [
    "The doctors in Salem really listen to your problems and make treatment plans that work.",
    "After trying many places, only H-Cura Salem could solve my skin problems completely.",
    "They care about patients and use natural ways to heal which I really like.",
  ];

  const handleServiceChange = (index) => {
    setIsChanging(true);
    setTimeout(() => {
      setActiveService(index);
      setIsChanging(false);
    }, 300);
  };

  const serviceLearnMoreUrl = (serviceId) => {
    switch (serviceId) {
      case "hair": return "/advanced-grow-hair-treatment";
      case "skin": return "/advanced-hydrafacial-treatment";
      case "dental": return "/dental-treatment";
      case "homeopathy": return "/homeopathy-best-treatments/";
      default: return "/services";
    }
  };

  const serviceIconMap = {
    hair: { url: tambaramhair, bgColor: "rgba(255,154,158,0.12)", borderColor: "rgba(255,154,158,0.18)", color: "#ff4d6d" },
    skin: { url: tambaramskin, bgColor: "rgba(255,223,121,0.12)", borderColor: "rgba(255,223,121,0.18)", color: "#ffb400" },
    dental: { url: "https://img.icons8.com/fluency/48/000000/tooth.png", bgColor: "rgba(144,238,144,0.12)", borderColor: "rgba(144,238,144,0.18)", color: "#28a745" },
    homeopathy: { url: tambaramleaf, bgColor: "rgba(135,206,250,0.12)", borderColor: "rgba(135,206,250,0.18)", color: "#0099cc" },
  };

  const treatmentIconMap = {
    "prp-icon": { url: "https://img.icons8.com/fluency/48/000000/syringe.png", bgColor: "rgba(255,140,140,0.06)", borderColor: "rgba(255,140,140,0.12)" },
    "gfc-icon": { url: "https://img.icons8.com/fluency/48/000000/biotech.png", bgColor: "rgba(170,200,255,0.06)", borderColor: "rgba(110,160,255,0.12)" },
    "hydrafacial-icon": { url: "https://img.icons8.com/fluency/48/000000/spa-care.png", bgColor: "rgba(200,255,230,0.06)", borderColor: "rgba(60,200,120,0.12)" },
    "antiaging-icon": { url: "https://img.icons8.com/fluency/48/000000/collagen.png", bgColor: "rgba(220,245,255,0.06)", borderColor: "rgba(80,200,240,0.12)" },
    "pigmentation-icon": { url: "https://img.icons8.com/fluency/48/000000/foundation-makeup.png", bgColor: "rgba(250,210,255,0.06)", borderColor: "rgba(220,120,240,0.12)" },
    "aligner-icon": { url: "https://img.icons8.com/fluency/48/000000/braces.png", bgColor: "rgba(230,230,255,0.06)", borderColor: "rgba(140,120,240,0.12)" },
    "hormonal-icon": { url: "https://img.icons8.com/fluency/48/000000/hormone.png", bgColor: "rgba(255,230,240,0.06)", borderColor: "rgba(240,160,200,0.12)" },
    "chronic-icon": { url: "https://img.icons8.com/fluency/48/000000/medical-pack.png", bgColor: "rgba(230,255,240,0.06)", borderColor: "rgba(160,240,200,0.12)" },
    "constitutional-icon": { url: "https://img.icons8.com/fluency/48/000000/holistic-therapy.png", borderColor: "rgba(160,160,240,0.12)" },
  };

  const SAMPLE_GALLERY = {
    hair: [
      { id: "hair-1", combined: img1, testimonial: { quote: "I was completely bald. After 6 months of PRP treatment, my hair came back!", author: "Rajesh K." } },
      { id: "hair-2", combined: img2, testimonial: { quote: "The bald spot on top of my head is now full of hair.", author: "Amit S." } },
      { id: "hair-3", combined: img3, testimonial: { quote: "My hairline was going back. Now it looks like when I was 20!", author: "Priya M." } },
      { id: "hair-4", combined: img4, testimonial: { quote: "GFC and QR678 treatment gave me natural hair regrowth.", author: "Karthik R." } },
      { id: "hair-5", combined: img5, testimonial: { quote: "Best decision I made. My hair grew back naturally.", author: "Deepak V." } },
      { id: "hair-6", combined: img6, testimonial: { quote: "In just 3 months, I could see more hair on my head.", author: "Anitha L." } },
      { id: "hair-7", combined: img7, testimonial: { quote: "From almost bald to full head of hair. Thank you!", author: "Suresh K." } },
      { id: "hair-8", combined: img8, testimonial: { quote: "My wife is shocked seeing my new hair.", author: "Vikram P." } },
      { id: "hair-9", combined: img9, testimonial: { quote: "My thin hair became thick again.", author: "Ramesh B." } },
      { id: "hair-10", combined: img10, testimonial: { quote: "After trying many places, only H-Cura could solve it.", author: "Mahesh T." } },
    ],
    skin: [
      { id: "skin-1", combined: img11, testimonial: { quote: "Had pimples for years. Now my face is completely clear!", author: "Sneha R." } },
      { id: "skin-2", combined: img12, testimonial: { quote: "HydraFacial removed all my dark spots.", author: "Kavya M." } },
      { id: "skin-3", combined: img13, testimonial: { quote: "The lines on my face are almost gone.", author: "Meera K." } },
      { id: "skin-4", combined: img14, testimonial: { quote: "My skin color became even all over.", author: "Preethi S." } },
      { id: "skin-5", combined: img15, testimonial: { quote: "The brown patches on my face disappeared completely.", author: "Divya L." } },
      { id: "skin-6", combined: img16, testimonial: { quote: "People say I look 5 years younger.", author: "Anjali P." } },
      { id: "skin-7", combined: img17, testimonial: { quote: "All my old pimple marks are gone.", author: "Rohit M." } },
      { id: "skin-8", combined: img18, testimonial: { quote: "The dark circles under my eyes are gone.", author: "Lakshmi V." } },
      { id: "skin-9", combined: img19, testimonial: { quote: "My loose skin became tight without surgery.", author: "Sunita K." } },
      { id: "skin-10", combined: img20, testimonial: { quote: "My whole face changed. Everyone asks what treatment I took.", author: "Ravi S." } },
    ],
  };

  const openTambaramBaModal = (serviceKey, startIndex = 0) => {
    setTambaramBaModalItems(SAMPLE_GALLERY[serviceKey]);
    setTambaramBaModalStartIndex(startIndex);
    setTambaramBaModalOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeTambaramBaModal = () => {
    setTambaramBaModalOpen(false);
    setTambaramBaModalItems([]);
    setTambaramBaModalStartIndex(0);
    document.body.style.overflow = "";
  };

  return (
    <div className="pondyhcura-hcura-chennai">
      <section className="tambaram-hcura-hero-section" style={{ position: 'relative', overflow: 'hidden' }}>
        <video autoPlay muted loop playsInline style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: -2 }}>
         <source src={hcuraHeroVideo} type="video/mp4" />
        </video>
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'linear-gradient(rgba(41, 33, 33, 0.3), rgba(112, 111, 111, 0.3))', zIndex: -1 }}></div>
        <div className="tambaram-hcura-hero-content-wrapper">
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="tambaram-hcura-primary-title">
            H-Cura Multispecialty Clinic in Salem, Tamil Nadu
          </motion.h1>
          <motion.h2 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.2 }} className="tambaram-hcura-secondary-title">
            Advanced Clinical Care for Hair, Skin & Dental Health
          </motion.h2>
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.4 }} className="tambaram-hcura-description-text">
            Looking for the Best Hair, Skin, Dental & Homeopathy Clinic in Salem? H-Cura Multispecialty Clinic offers advanced hair loss treatment in Salem, professional skin clinic services, cosmetic and general dental care, and certified homeopathy treatment under experienced doctors. We provide specialized solutions for hair fall, acne and pigmentation treatments, PRP hair treatment in Salem, laser skin procedures, teeth cleaning, root canal care, and natural hormone-balancing therapies designed for long-term wellness. Conveniently located in Salem, our clinic is trusted by patients searching for the best hair clinic in Salem, best skin treatment clinic in Salem, best dental clinic in Salem, and best homeopathy clinic in Salem. At H-Cura Salem, we focus on accurate diagnosis, personalized treatment plans, affordable hair loss treatment in Salem, and visible results — book your appointment today and experience expert healthcare close to home.
          </motion.p>
          <motion.div className="tambaram-hcura-action-buttons" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.6 }}>
            <Link to="/bookconsultation" className="tambaram-hcura-btn-primary">Book Appointment</Link>
            <a href="https://wa.me/919964688333" className="tambaram-hcura-btn-secondary" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp /> WhatsApp Consult
            </a>
          </motion.div>
        </div>
      </section>
            {/* Modal viewer for detailed view with scrolling - ADD THIS BLOCK */}
      {valasaravakamchennaiBaModalOpen && (
        <div
          className="pondyhcura-ba-modal"
          role="dialog"
          aria-modal="true"
          aria-label="Before and after detailed gallery"
        >
          <div
            className="pondyhcura-ba-modal-backdrop"
            onClick={closeTambaramBaModal}
          />
          <div className="pondyhcura-ba-modal-panel">
            <header className="pondyhcura-ba-modal-header">
              <h3>Treatment Results - H-Cura Salem</h3>
              <button
                className="pondyhcura-ba-modal-close"
                onClick={closeTambaramBaModal}
                aria-label="Close photos"
              >
                ×
              </button>
            </header>

            <div className="pondyhcura-ba-modal-body">
              <div className="pondyhcura-ba-scrollable-container">
                <div
                  className="pondyhcura-ba-scroll-track"
                  id="scrollTrack"
                >
                  <div
                    className="pondyhcura-ba-scrollable-grid"
                    id="scrollableGrid"
                  >
                    {valasaravakamchennaiBaModalItems.map((item, index) => (
                      <div
                        key={item.id}
                        className="pondyhcura-ba-scrollable-card"
                        data-index={index}
                      >
                        <div className="pondyhcura-ba-scrollable-image-container">
                          <img
                            src={item.combined}
                            alt={`${item.title} results at H-Cura Salem`}
                            className="pondyhcura-ba-scrollable-image"
                          />
                        </div>
                        <div className="pondyhcura-ba-scrollable-content">
                          <h4>{item.title}</h4>
                          <p className="pondyhcura-ba-scrollable-testimonial">
                            "{item.testimonial?.quote || ""}"
                          </p>
                          <div className="pondyhcura-ba-scrollable-author">
                            — {item.testimonial?.author || ""}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="pondyhcura-ba-scroll-progress">
                  <div
                    className="pondyhcura-ba-progress-bar"
                    id="progressBar"
                  ></div>
                </div>
              </div>

              <div className="pondyhcura-ba-enhanced-controls">
                <div className="pondyhcura-ba-nav-buttons">
                  <button
                    className="pondyhcura-ba-nav-btn pondyhcura-ba-prev-btn"
                    id="prevBtn"
                    onClick={() => scrollGallery("prev")}
                  >
                    Previous
                  </button>

                  <button
                    className="pondyhcura-ba-nav-btn pondyhcura-ba-next-btn"
                    id="nextBtn"
                    onClick={() => scrollGallery("next")}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}


      <section id="before-after" className="pondyhcura-before-after">
        <div className="pondyhcura-section-header">
          <span className="pondyhcura-section-subtitle">Real Results. Real Transformations. – H-Cura Salem</span>
          <h2>Before & After Treatment Photos</h2>
          <div className="pondyhcura-decorative-line"><span className="pondyhcura-decorative-icon"><FaArrowRight /></span></div>
          <p className="pondyhcura-section-description">
            At H-Cura Multispecialty Clinic in Salem, we don’t just promise results — we deliver visible transformations. Our Before & After gallery showcases real patients who achieved significant improvement in hair regrowth, acne reduction, pigmentation correction, smile enhancement, and holistic wellness treatments. Every transformation reflects our commitment to advanced techniques, personalized treatment plans, and medically guided care. Patients across Salem trust H-Cura for treatments that create measurable, confidence-boosting results including PRP therapy for hair loss in Salem and advanced skin care solutions. Don’t just read about success stories — explore our complete gallery and see how our Salem clinic turns concerns into confidence.
          </p>
        </div>
        <div className="pondyhcura-before-tabs">
          {["hair", "skin"].map((s, idx) => (
            <button key={s} className={`pondyhcura-ba-tab ${activeService === idx ? "active" : ""}`} onClick={() => handleServiceChange(idx)}>
              {s.charAt(0).toUpperCase() + s.slice(1)}
            </button>
          ))}
        </div>
        <div className="pondyhcura-before-carousel-wrapper">
          <div className="pondyhcura-before-carousel" role="list">
            {(() => {
              const svcKey = activeService === 0 ? "hair" : "skin";
              const items = SAMPLE_GALLERY[svcKey] || [];
              return items.map((item, idx) => (
                <article key={item.id} className="pondyhcura-ba-clean-card" role="listitem">
                  <div className="pondyhcura-ba-clean-container">
                    <div className="pondyhcura-ba-clean-image-wrapper">
                      <img src={item.combined} alt={`${item.title} at H-Cura Salem`} className="pondyhcura-ba-clean-image" />
                    </div>
                    <div className="pondyhcura-ba-clean-actions">
                      <button className="pondyhcura-ba-clean-view-btn" onClick={() => openTambaramBaModal(svcKey, idx)}>See More Photos</button>
                    </div>
                  </div>
                </article>
              ));
            })()}
          </div>
        </div>
      </section>

      <section id="why-choose" className="pondyhcura-why-choose-enhanced">
        <div className="pondyhcura-content-wrapper">
          <motion.div className="pondyhcura-section-header" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
            <span className="pondyhcura-section-subtitle">Best Healthcare</span>
            <h2>Why H-Cura is One of the Most Trusted Clinics in Salem</h2>
            <div className="pondyhcura-decorative-line"><span className="pondyhcura-decorative-icon"><FaShieldAlt /></span></div>
            <p className="pondyhcura-section-description">
              Choosing the right clinic in Salem can make the difference between temporary relief and real transformation. At H-Cura Multispecialty Clinic in Salem, Tamil Nadu, we focus on evidence-based treatments, personalized care, and visible results across Hair Restoration, Skin Treatments, Dental Care, and Homeopathy. Patients searching for the best hair treatment in Salem, advanced hair treatment in Salem, and best hair doctor in Salem choose H-Cura because we combine advanced technology with ethical medical practice and transparent consultation. From PRP treatment for hair and skin in Salem to comprehensive dental treatments, every service is designed to address root causes, not just symptoms, ensuring safe procedures, measurable improvement, and complete patient satisfaction. At H-Cura Salem, your health, confidence, and comfort remain our top priority from first consultation to follow-up care.
            </p>
          </motion.div>
          <motion.div className="pondyhcura-features-grid" ref={whyChooseRef} variants={containerVariants} initial="hidden" animate={whyChooseControls}>
            {features.map((feature, index) => (
              <motion.div className="pondyhcura-feature-card-enhanced" key={index} variants={itemVariants}>
                <div className="pondyhcura-feature-header">
                  <div className="pondyhcura-icon-container">{feature.icon}</div>
                  <span className="pondyhcura-feature-highlight">{feature.highlight}</span>
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </motion.div>
            ))}
          </motion.div>
          <div className="pondyhcura-cta-container">
            <h3>Experience the H-Cura Salem Difference</h3>
            <p>Join many satisfied patients who have improved their health, appearance, and confidence through expert care at H-Cura Multispecialty Clinic in Salem.</p>
            <Link to="/bookconsultation" className="pondyhcura-cta-button">Book Your Visit</Link>
          </div>
        </div>
      </section>

      <section id="services" className="pondyhcura-services-premium-section" ref={sectionRef}>
        <div className="pondyhcura-services-container">
          <div className={`pondyhcura-services-header ${isVisible ? "visible" : ""}`}>
            <span className="pondyhcura-services-subtitle">Best Healthcare</span>
            <h2>Our Services at H-Cura Salem</h2>
            <p className="pondyhcura-services-description">
              Experience advanced treatments delivered with precision and care in Salem. Our comprehensive range of services combines modern medical technology with natural healing approaches to support overall wellness.
            </p>
          </div>
          <div className={`pondyhcura-services-tabs ${isVisible ? "visible" : ""}`}>
            {advancedServices.map((service, index) => {
              const sIcon = serviceIconMap[service.id] || null;
              const isActive = activeService === index;
              return (
                <button key={service.id} className={`pondyhcura-service-tab ${isActive ? "active" : ""}`} onClick={() => handleServiceChange(index)}>
                  <span className={`pondyhcura-tab-icon bright-icon`} style={{ backgroundImage: sIcon ? `url('${sIcon.url}')` : undefined, backgroundSize: "60%", backgroundPosition: "center", backgroundColor: sIcon?.bgColor, borderRadius: "12px", width: "44px", height: "44px", display: "inline-block" }}></span>
                  <span className="pondyhcura-tab-text">{service.id.charAt(0).toUpperCase() + service.id.slice(1)}</span>
                </button>
              );
            })}
          </div>
          <div className={`pondyhcura-service-content-wrapper ${isVisible ? "visible" : ""}`}>
            <div className={`pondyhcura-service-main-content ${isChanging ? "changing" : ""}`}>
              <div className="pondyhcura-service-info">
                <h3>{advancedServices[activeService].title}</h3>
                <h4>{advancedServices[activeService].subtitle}</h4>
                <p>{advancedServices[activeService].description}</p>
                <div className="pondyhcura-service-cta">
                  <Link to="/bookconsultation" className="pondyhcura-service-btn">Meet Doctor</Link>
                </div>
              </div>
              <div className="pondyhcura-service-image-container">
                <img src={advancedServices[activeService].image} alt={advancedServices[activeService].title} className="pondyhcura-service-main-image" />
              </div>
            </div>
                        <div className="pondyhcura-service-treatments">
              <h4>Special Treatments</h4>
              <div className="pondyhcura-treatments-slider">
                {advancedServices[activeService].treatments.map(
                  (treatment, tIndex) => {
                    const tIcon = treatmentIconMap[treatment.icon] || null;
                    return (
                      <div
                        className="pondyhcura-treatment-card"
                        key={tIndex}
                      >
                        <div className="pondyhcura-treatment-image">
                          <img
                            src={treatment.image}
                            alt={`${treatment.name} treatment at H-Cura Salem`}
                            title={`${treatment.name} - Special treatment at H-Cura Salem`}
                          />
                        </div>
                        <div className="pondyhcura-treatment-content">
                          <div
                            className="pondyhcura-treatment-icon"
                            style={{
                              backgroundImage: tIcon ? `url('${tIcon.url}')` : undefined,
                              backgroundSize: "60% auto",
                              backgroundPosition: "center",
                              backgroundRepeat: "no-repeat",
                              backgroundColor: tIcon ? tIcon.bgColor : undefined,
                              border: tIcon ? `2px solid ${tIcon.borderColor}` : undefined,
                              width: "56px",
                              height: "56px",
                              borderRadius: "12px",
                            }}
                          ></div>
                          <h5>{treatment.name}</h5>
                          <p>{treatment.description}</p>
                          <div className="pondyhcura-treatment-benefits">
                            <h6>Good Points:</h6>
                            <ul>
                              {treatment.benefits.map((benefit, i) => (
                                <li key={i}>
                                  <span className="pondyhcura-benefit-icon">✓</span>
                                  {benefit}
                                </li>
                              ))}
                            </ul>
                          </div>

                          <div className="pondyhcura-treatment-cta">
                            <Link
                              className="pondyhcura-treatment-learnmore"
                              to={serviceLearnMoreUrl(advancedServices[activeService].id)}
                            >
                              Know More
                            </Link>
                          </div>
                        </div>
                      </div>
                    );
                  }
                )}
              </div>
            </div>

          </div>
        </div>
      </section>

      <section id="locations" className="pondyhcura-locations">
        <div className="pondyhcura-section-header">
          <h2>Our Clinic Locations</h2>
          <p>Find the nearest H-Cura clinic for your health needs</p>
        </div>
        <div className="pondyhcura-location-tabs">
          <Link to="/multispecialty-clinic-in-salem-tamilnadu" className={`pondyhcura-location-tab active`}><FaMapMarkerAlt /> Salem</Link>
        </div>
        <div className="pondyhcura-location-details">
          <div className="pondyhcura-location-card">
            <div className="pondyhcura-location-header">
              <h3>{locations.salem.name} Clinic</h3>
              <span className="pondyhcura-specialty-tag">{locations.salem.specialties}</span>
            </div>
            <div className="pondyhcura-location-grid">
              <div className="pondyhcura-location-info">
                <div className="pondyhcura-info-item"><FaMapMarkerAlt /><div><h4>Address</h4><p>{locations.salem.address}</p></div></div>
                <div className="pondyhcura-info-item"><FaPhone /><div><h4>Phone</h4><p>{locations.salem.phone}</p></div></div>
                <div className="pondyhcura-info-item"><FaClock /><div><h4>Open Hours</h4><p>{locations.salem.hours}</p></div></div>
              </div>
              <div className="pondyhcura-popular-services">
                <h4>Popular Treatments</h4>
                <ul>{locations.salem.popularServices.map((s, i) => <li key={i}><FaCheckCircle /> {s}</li>)}</ul>
                <a href={locations.salem.mapUrl} target="_blank" rel="noopener noreferrer" className="pondyhcura-map-link">
                  See on Map <FaArrowRight />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="testimonials" className="pondyhcura-testimonials">
        <div className="pondyhcura-section-header">
          <h2>What Our Salem Patients Say</h2>
          <p>Hear from patients across Salem who have improved their health and confidence at H-Cura:</p>
        </div>
        <div className="pondyhcura-testimonials-grid">
          {testimonials.map((t, index) => (
            <motion.div className="pondyhcura-testimonial-card" key={index} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
              <div className="pondyhcura-testimonial-rating">{[...Array(5)].map((_, i) => <FaStar key={i} className="pondyhcura-star-filled" />)}</div>
              <p className="pondyhcura-testimonial-text">"{t.text}"</p>
              <div className="pondyhcura-testimonial-author">
                <h4>{t.name}</h4>
                <p>{t.location} • {t.service}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      <section id="appointment" className="pondyhcura-appointment" style={{ position: "relative", overflow: "hidden", color: "#fff" }}>
        <video autoPlay muted loop playsInline style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover", zIndex: -2 }}>
          <source src={hcuraHeroVideo2} type="video/mp4" />
        </video>
        <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", background: "linear-gradient(rgba(0,0,0,0.65), rgba(0,0,0,0.65))", zIndex: -1 }}></div>
        <div className="pondyhcura-appointment-content">
          <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}>Book Your Appointment at H-Cura Salem Today</motion.h2>
          <motion.p initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}>
            Take the first step toward better health, glowing skin, stronger hair, and a confident smile. Schedule your visit with H-Cura Multispecialty Clinic in Salem and experience expert care designed for your health and wellness.
          </motion.p>
          <div className="pondyhcura-contact-options">
            <div className="pondyhcura-contact-option"><FaPhone /> <span>+91 99646 88333</span></div>
            <div className="pondyhcura-contact-option"><FaGlobe /> <a href="https://h-cura.com" target="_blank" rel="noopener noreferrer">www.h-cura.com</a></div>
          </div>
          <div className="pondyhcura-appointment-buttons">
            <Link to="/bookconsultation" className="pondyhcura-primary-button">Book Appointment</Link>
            <a href="https://wa.me/919964688333" className="pondyhcura-whatsapp-button" target="_blank" rel="noopener noreferrer"><FaWhatsapp /> WhatsApp Us</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Salem;
